// import apiClient from './client';

// export const stockTransfersAPI = {
//   getAll: () => apiClient.get('/stock-transfers/'),
//   getById: (id) => apiClient.get(`/stock-transfers/${id}/`),
//   create: (data) => apiClient.post('/stock-transfers/', data),
//   update: (id, data) => apiClient.patch(`/stock-transfers/${id}/`, data),
//   delete: (id) => apiClient.delete(`/stock-transfers/${id}/`),
//   approve: (id) => apiClient.post(`/stock-transfers/${id}/approve/`),
//   reject: (id) => apiClient.post(`/stock-transfers/${id}/reject/`),
// };


// src/api/stockTransfers.js
import apiClient from './client';

export const stockTransfersAPI = {
  getAll: () => apiClient.get('/stock-transfers/'),
  getById: (id) => apiClient.get(`/stock-transfers/${id}/`),
  create: (data) => apiClient.post('/stock-transfers/', data),
  update: (id, data) => apiClient.patch(`/stock-transfers/${id}/`, data),
  delete: (id) => apiClient.delete(`/stock-transfers/${id}/`),
  execute: (id) => apiClient.post(`/stock-transfers/${id}/execute/`), 
  cancel: (id) => apiClient.post(`/stock-transfers/${id}/cancel/`),    
};
